import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7c970202")
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "page-summary row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = {
  key: 0,
  class: "container-md gx-0"
}
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 gx-0" }
const _hoisted_8 = {
  id: "offersSection",
  class: "position-relative"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  id: "anchor-offersSection",
  class: "anchor"
}, null, -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = {
  key: 0,
  class: "page-summary_content col-12"
}
const _hoisted_12 = { class: "page-summary_loader color-primary fw-semi-bold fs-24 lh-36 text-center" }
const _hoisted_13 = {
  key: 0,
  class: "loader"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 1,
  class: "page-summary_blurred container"
}
const _hoisted_16 = { class: "container pt-5" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notus_header = _resolveComponent("notus-header")!
  const _component_notus_hero = _resolveComponent("notus-hero")!
  const _component_notus_intro = _resolveComponent("notus-intro")!
  const _component_notus_summary_parameters = _resolveComponent("notus-summary-parameters")!
  const _component_notus_sorting = _resolveComponent("notus-sorting")!
  const _component_notus_offers = _resolveComponent("notus-offers")!
  const _component_notus_button = _resolveComponent("notus-button")!
  const _component_notus_svg_icon = _resolveComponent("notus-svg-icon")!
  const _component_notus_cta_interested = _resolveComponent("notus-cta-interested")!
  const _component_notus_contact_us_section = _resolveComponent("notus-contact-us-section")!
  const _component_notus_why_us_section = _resolveComponent("notus-why-us-section")!
  const _component_notus_summary_footer_section = _resolveComponent("notus-summary-footer-section")!
  const _component_notus_summary_comparition_bar = _resolveComponent("notus-summary-comparition-bar")!
  const _component_notus_page_offer_details = _resolveComponent("notus-page-offer-details")!
  const _component_notus_expand_page = _resolveComponent("notus-expand-page")!
  const _component_notus_button_scroll_top = _resolveComponent("notus-button-scroll-top")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_notus_header, {
          partnerLogoUrl: _ctx.partnerLogo,
          onCloseClicked: _ctx.notusClose,
          shallAskConfirmaton: true
        }, null, 8, ["partnerLogoUrl", "onCloseClicked"])
      ]),
      _createVNode(_component_notus_hero),
      _createVNode(_component_notus_intro),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_notus_summary_parameters)
          ])
        ])
      ]),
      (!_ctx.isLoading && _ctx.offers?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_notus_sorting)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createElementVNode("div", {
          class: _normalizeClass(["container-md page-summary position-relative", {'page-summary--loading': _ctx.isLoading || !_ctx.isValid}])
        }, [
          _createElementVNode("div", _hoisted_10, [
            (!_ctx.isLoading && _ctx.offers?.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_notus_offers)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.isValid)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              innerHTML: _ctx.isValid ? _ctx.$t('page.summary.loader.loading') : _ctx.$t('page.summary.loader.invalid')
            }, null, 8, _hoisted_14),
            (!_ctx.isValid)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollToContact())),
                  class: "d-inline-block mt-3 mt-md-4 cursor-pointer",
                  tabindex: "0",
                  role: "button"
                }, [
                  _createVNode(_component_notus_button, {
                    class: "px-4",
                    size: "large",
                    theme: "link"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('section.cta-interested.button.noOffers')), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_notus_svg_icon, {
                    class: "icon rotated d-inline-block",
                    iconType: "arrow_top_rounded"
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ], 2),
        (_ctx.isValid && !_ctx.isLoading && _ctx.offers && !_ctx.offers.length)
          ? (_openBlock(), _createBlock(_component_notus_cta_interested, {
              key: 0,
              class: "mt-3"
            }))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.isLoading && _ctx.offers?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createVNode(_component_notus_svg_icon, {
              iconType: "blurred",
              cover: true,
              class: "d-none d-md-block"
            }),
            _createVNode(_component_notus_svg_icon, {
              iconType: "blurred_mobile",
              cover: true,
              class: "d-block d-md-none"
            })
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_notus_contact_us_section, {
        class: _normalizeClass(["page-summary_contact_us mb-5", {
        'page-summary_contact_us--overwrapped': !_ctx.isLoading && _ctx.offers?.length,
      }])
      }, null, 8, ["class"]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_notus_why_us_section),
        _createVNode(_component_notus_summary_footer_section)
      ]),
      (_ctx.compareElementsAmount > 0)
        ? (_openBlock(), _createBlock(_component_notus_summary_comparition_bar, { key: 2 }))
        : _createCommentVNode("", true),
      _createVNode(_component_notus_expand_page, {
        opened: _ctx.detailedOffer !== undefined
      }, {
        default: _withCtx(() => [
          _createVNode(_component_notus_page_offer_details, { key: _ctx.detailedOffer })
        ]),
        _: 1
      }, 8, ["opened"])
    ]),
    _createVNode(_component_notus_button_scroll_top, {
      class: _normalizeClass({'page-summary_scroll-top--with-compare-bar': _ctx.compareElementsAmount > 0})
    }, null, 8, ["class"])
  ], 64))
}